import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

// antd
import { Col, Form, Input, message, Row, theme, Typography } from 'antd'

// slices
import { passwordForgot } from './login.slice'

// routes
import { PUBLIC_ROUTES } from '../../routes'

// css
import './LoginForm.css'

// components
import Button from '../../components/button/button'

// constants
import { FORM_VALIDATION_RULES } from '../../constants/validationRules/form'

// assets
import { PasswordHideIcon, PasswordShowIcon } from '../../assets/icons'
import { showActionNotification } from '../../components/notification'

function UpdatePassword() {
    const [form] = Form.useForm()

    const { Title } = Typography

    const { useToken } = theme

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const { token } = useToken()

    const [loadingButton, setLoadingButton] = useState(false)

    function onFinishFailed() {}

    async function onUpdatePassword(value) {
        setLoadingButton(true)

        const result = await dispatch(
            passwordForgot({
                userId: localStorage.getItem('userId'),
                password: value.password,
            })
        )
        const data = result?.payload?.data
        if (data) {
            const { success, message: checkMessage } = data
            if (success) {
                setLoadingButton(false)
                showActionNotification({
                    type: 'success',
                    message: checkMessage,
                })
                navigate(PUBLIC_ROUTES.successfullyResetPassword)
            } else {
                setLoadingButton(false)
                if (checkMessage) {
                    showActionNotification({
                        type: 'error',
                        message: checkMessage,
                    })
                } else {
                    showActionNotification({
                        type: 'error',
                        message: 'Something went wrong, try again later.',
                    })
                }
            }
        }
    }

    return (
        <div
            style={{
                padding: '60px 60px 0px 60px',
            }}
        >
            <Title level={3}>Update Password</Title>
            <Form
                layout="vertical"
                name="updatePassword"
                onFinish={onUpdatePassword}
                onFinishFailed={onFinishFailed}
                requiredMark={false}
                form={form}
                style={{
                    marginTop: '20px',
                }}
            >
                <Col
                    span={24}
                    style={{
                        padding: '0px',
                        marginBottom: '10px',
                    }}
                >
                    <Form.Item
                        label="New Password"
                        name="password"
                        rules={[
                            {
                                ...FORM_VALIDATION_RULES.password.required,
                                message: 'Please Enter Password',
                            },
                            FORM_VALIDATION_RULES.password.strongWithMaxLength,
                        ]}
                        colon={false}
                    >
                        <Input.Password
                            placeholder="Enter Password"
                            style={{
                                padding: '0px 11px',
                            }}
                            iconRender={(visible) =>
                                visible ? (
                                    <div
                                        onClick={() => {}}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <PasswordShowIcon />
                                    </div>
                                ) : (
                                    <div
                                        onClick={() => {}}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <PasswordHideIcon />
                                    </div>
                                )
                            }
                        />
                    </Form.Item>
                </Col>
                <Col
                    span={24}
                    style={{
                        padding: '0px',
                        marginBottom: '10px',
                    }}
                >
                    <Form.Item
                        label="Confirm Password"
                        name="passwordConfirm"
                        dependencies={['password']}
                        rules={FORM_VALIDATION_RULES.password.confirm(
                            'password',
                            'Please Enter Password',
                            'The Password that you entered do not match!'
                        )}
                        colon={false}
                    >
                        <Input.Password
                            placeholder="Enter Password"
                            style={{
                                padding: '0px 11px',
                            }}
                            iconRender={(visible) =>
                                visible ? (
                                    <div
                                        onClick={() => {}}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <PasswordShowIcon />
                                    </div>
                                ) : (
                                    <div
                                        onClick={() => {}}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <PasswordHideIcon />
                                    </div>
                                )
                            }
                        />
                    </Form.Item>
                </Col>
                <Row
                    gutter={20}
                    style={{
                        marginTop: '20px',
                    }}
                >
                    <Col span={24}>
                        <Button
                            props={{
                                text: 'Log In',
                                htmlType: 'submit',
                                style: {
                                    backgroundColor:
                                        token.colorPalette.registrationColor
                                            .secondary,
                                    width: '100%',
                                },
                                disabled: loadingButton,
                                loadingButton: loadingButton,
                            }}
                        />
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default UpdatePassword
